import { formatNo } from './truckCatalog';

export const MAX_HOURS = 12;

const fmtKr = n => Number(n).toLocaleString('nb-NO');

// Totalpris for et timeoppdrag. null ved ugyldige timer (hele timer 1–12) eller timepris.
export function hourlyTotal(hours, rate) {
  const h = Number(hours), r = Number(rate);
  if (!Number.isInteger(h) || h < 1 || h > MAX_HOURS || !(r > 0)) return null;
  return h * r;
}

// Overtid: minutter (1–240) rundes opp til nærmeste 15, beløp = timepris/60 × minutter, hele kroner. Må stemme med functions/src/hourly.js.
export function overtimeAmount(minutes, rate) {
  const m = Number(minutes), r = Number(rate);
  if (!Number.isFinite(m) || m < 1 || m > 240 || !(r > 0)) return null;
  const billed = Math.ceil(m / 15) * 15;
  return Math.round(r / 60 * billed);
}

// Effektiv timepris: min(hourly.rate, agreedPrice / hourly.hours) når et avtalt beløp (vinnerbud/fastpris) finnes, ellers hourly.rate.
// Må stemme med functions/src/hourly.js. null uten gyldig timepris.
export function effectiveHourlyRate(order) {
  const h = order?.hourly;
  const rate = Number(h?.rate);
  if (!(rate > 0)) return null;
  const hours = Number(h?.hours), agreed = Number(order?.agreedPrice);
  if (hours >= 1 && agreed > 0) return Math.min(rate, agreed / hours);
  return rate;
}

// «8 timer à 1 100 kr/time», eller null for ordre uten timepris.
export function orderHourlyText(order) {
  const h = order?.hourly;
  if (!h || !(h.hours >= 1) || !(h.rate > 0)) return null;
  return `${h.hours} ${h.hours === 1 ? 'time' : 'timer'} à ${fmtKr(h.rate)} kr/time`;
}

// «12 tonn» / «20 sekker», eller null når mengden mangler (timeoppdrag uten mengde).
export function orderQtyText(order) {
  if (order?.estimatedTons == null) return null;
  return `${formatNo(order.estimatedTons)} ${order.unit === 'bags' ? 'sekker' : 'tonn'}`;
}
